const importsApi = ({ apiClient }) => ({
  store(payload) {
    return apiClient.post('imports', payload, false, {})
  },

  list(params, headers = {}) {
    return apiClient.get(
      'imports',
      {},
      {
        ...params,
      },
      headers,
    )
  },

  show(id, param = {}, headers = {}) {
    return apiClient.get(`imports/${id}/status`, {}, param, headers)
  },
})

export default importsApi
